


















































































































































































































































































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import tippy from 'tippy.js';

@Component({})
export default class TextInput extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop() text!: string;
  @Prop() value!: string;
  @Prop() readOnly!: boolean;
  @Prop({ default: null }) mask!: string;
  @Prop({ default: '' }) displayName!: string;
  @Prop({ default: false }) required!: boolean | string;
  @Prop({ default: false }) email!: boolean;
  @Prop({ default: false }) light!: boolean;
  @Prop({ default: false }) password!: boolean;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: false }) textarea!: boolean;
  @Prop() errorMessage?: string;
  @Prop({ default: false }) hasPlaceholderLeft?: boolean;
  @Prop({ default: '' }) title?: string;
  @Prop({ default: false }) noPadding?: boolean;
  @Prop({ default: false }) noBackground?: boolean;
  @Prop({ default: false }) numeric?: boolean;
  @Prop({ default: false }) alwaysShowTitle?: boolean;
  @Prop({ default: 524288 }) maxLength?: number;
  @Prop({ default: false }) showCounter!: boolean;
  @Prop({ default: false }) secondaryTitle?: boolean;
  @Prop({ default: false }) highlightError!: boolean;
  @Prop({ default: '' }) info!: string;
  @Prop({ default: '' }) tippyTemplate!: string;
  @Prop({ default: false }) secondary!: boolean;
  @Prop({ default: null }) hint!: string;
  @Prop({ default: false }) hasSearch!: boolean;
  @Prop({ default: 'on' }) autocomplete!: string;
  @Prop({ default: false }) deactiveAutocorrect!: boolean;
  @Prop({ default: false }) secondarylightError!: boolean;
  @Prop({ default: 'white' }) colorSchema!: 'white' | 'dark';

  isNotPassword: boolean = false;

  mounted() {
    if (this.info) tippy('[data-tippy-content]');
    else if (this.tippyTemplate) {
      const { tippyTemplate } = this;
      tippy(`#${tippyTemplate}-container`, {
        content(reference) {
          const template = document.getElementById(tippyTemplate);
          if (template) return template.innerHTML;

          return '';
        },
        allowHTML: true,
        theme: 'light',
        maxWidth: 1000
      });
    }
  }

  public get maskTreated(): string[] {
    return `${this.mask}`.split(',');
  }

  toggleType() {
    this.isNotPassword = !this.isNotPassword;
  }

  get getCharacterCounter(): number {
    return this.value.length;
  }

  get getMaxLenght(): number {
    return this.maxLength || 524288;
  }

  get getCounter() {
    return this.getMaxLenght - this.getCharacterCounter;
  }
}
